import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

import { AppSessionService } from './session/app-session.service';
import { AppUrlService } from './nav/app-url.service';
import { AppAuthService } from './auth/app-auth.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { LocalizePipe } from '@shared/pipes/localize.pipe';

import { AbpPaginationControlsComponent } from './components/pagination/abp-pagination-controls.component';
import { AbpValidationSummaryComponent } from './components/validation/abp-validation.summary.component';
import { AbpModalHeaderComponent } from './components/modal/abp-modal-header.component';
import { AbpModalFooterComponent } from './components/modal/abp-modal-footer.component';
import { LayoutStoreService } from './layout/layout-store.service';

import { BusyDirective } from './directives/busy.directive';
import { EqualValidator } from './directives/equal-validator.directive';

import { SelectDropdownComponent } from './components/select-dropdown/select-dropdown.component';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { CustomConfirmComponent } from './components/custom-confirm/custom-confirm.component';
import { SelectMultiDropdownComponent } from './components/select-multi-dropdown/select-multi-dropdown.component';
import { SysWorkFlowComponent } from './components/sys-work-flow/sys-work-flow.component';
import { SysWorkFlowDialogComponent } from './components/sys-work-flow/sys-work-flow-dialog.component';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { GaugeChartComponent } from './components/gauge-chart/gauge-chart.component';
import { HorizontalChartComponent } from './components/horizontal-chart/horizontal-chart.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        NgMultiSelectDropDownModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        AngularMultiSelectModule
    ],
    declarations: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalHeaderComponent,
        AbpModalFooterComponent,
        LocalizePipe,
        BusyDirective,
        EqualValidator,
        SelectDropdownComponent,
        MultiSelectDropdownComponent,
        CustomConfirmComponent,
        SelectMultiDropdownComponent,
        SysWorkFlowComponent,
        SysWorkFlowDialogComponent,
        PieChartComponent,
        LineChartComponent,
        BarChartComponent,
        GaugeChartComponent,
        HorizontalChartComponent,
        TruncatePipe,
        FileViewerComponent
    ],
    exports: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalHeaderComponent,
        AbpModalFooterComponent,
        LocalizePipe,
        BusyDirective,
        EqualValidator,
        SelectDropdownComponent,
        MultiSelectDropdownComponent,
        SelectMultiDropdownComponent,
        SysWorkFlowComponent,
        SysWorkFlowDialogComponent,
        PieChartComponent,
        LineChartComponent,
        BarChartComponent,
        GaugeChartComponent,
        HorizontalChartComponent,
        TruncatePipe,
        FileViewerComponent
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [AppSessionService, AppUrlService, AppAuthService, AppRouteGuard, LayoutStoreService]
        };
    }
}
